import { IconResolver } from './icon-resolver';

const svgImports = import.meta.glob<string>('./svg/*.svg', { import: 'default' });

export class LazyIconLoader extends IconResolver {
  /**
   * Load the SVG contents for the given icon key, each icon from its own chunk.
   *
   * @param key The icon key to load the SVG for
   */
  public async loadSvg(key: string | null | undefined): Promise<string | null> {
    const resolvedKey = this.resolve(key);

    if (resolvedKey === null) {
      return null;
    }

    return (await svgImports[`./svg/${resolvedKey}.svg`]?.()) ?? null;
  }
}
